import { useQuery } from '@tanstack/react-query';
import base from '@/_api/base';
import type { ApiResponseError, QueryKey, UseQueryOptions } from '@/_api/types';

/**
 * TanStack Query v5 read wrapper — `queryFn` calls `base.get` with shared error mapping.
 */
export function useGetQuery<T>(
  getEndpoint: () => string,
  requestOptions: object,
  queryKey: QueryKey,
  queryOptions?: Omit<
    UseQueryOptions<T, ApiResponseError>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery<T, ApiResponseError>({
    queryKey,
    queryFn: () => base.get<T>(getEndpoint(), requestOptions),
    ...(queryOptions ?? {}),
  });
}

export default useGetQuery;
